import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
  };

  //const token = localStorage.getItem("token")
 export const getAllCumulativeReport = async (requestData) => {
  try {
    const { FromDateTime, ToDateTime } = requestData;
    const token = getToken();
    // Log the requestData to ensure it contains the expected properties
    const response = await axiosInstance.get(API_BASE_URL1 + `TrafficMarshalReport/GetTMCumulativeOperationsReport?FromDateTime=${FromDateTime}&ToDateTime=${ToDateTime}`, 
      { 
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};


  export const getAllUnloadingReport = async (requestData) => {
    try {
      const { FromDate,ToDate,ownerType,vehicleType } = requestData;
      const ownerId = ownerType == null ? '' : ownerType;
    const vehicleId = vehicleType == null ? '' : vehicleType;
   
      const response = await axiosInstance.get(API_BASE_URL1 + `TrafficMarshalReport/VehicleUnloadingWaitTimeReportResult?FromDate=${FromDate}&ToDate=${ToDate}&VehicleTypeId=${vehicleId}&OwnerTypeId=${ownerId}`, 
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getAllTotalWeighmentReport = async (requestData) => {

    try {
      const { FromDate,ToDate,ownerType,vehicleType } = requestData;
      const ownerId = ownerType == null ? '' : ownerType;
    const vehicleId = vehicleType == null ? '' : vehicleType;
      // Log the requestData to ensure it contains the expected properties
      console.log('requestData:', requestData);
  
      const response = await axiosInstance.get(API_BASE_URL1 + `TrafficMarshalReport/GetVehicleTotalWeighmentDetails?FromDate=${FromDate}&ToDate=${ToDate}&VehicleTypeId=${vehicleId}&OwnerTypeId=${ownerId}`, 
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getLiveReports = async () => {
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `TrafficMarshalReport/CountGroupedByOperationType`, 
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getLiveInnerReports = async (operationTypeId) => {
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `TrafficMarshalReport/GetTransactionsByOperationType?operationTypeId=${operationTypeId}`, 
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getTrafficMarshalSummaryData = async (StartDate,EndDate,ownerType,vehicleType) => {
    // const { StartDate,EndDate } = requestData;
    const ownerId = ownerType === null ? '' : ownerType;
    const vehicleId = vehicleType === null ? '' : vehicleType;
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `GeoFence/GetGeoFenceAndTrafficMarshalSummaryData?StartDate=${StartDate}&EndDate=${EndDate}&VehicleTypeId=${vehicleId}&OwnerTypeId=${ownerId}`, 
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  